import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Grid, IconButton, Typography } from '@mui/material';
import { ProcureUser } from 'vendor-marketplace-shared-library';
import { useState } from 'react';
import { UserAvatarGroup } from '../common/UserAvatarGroup';
import { DropdownWithCheckboxes } from '../common/DropdownWithCheckboxes';

type WatchersSelectionProps = {
  watcherIds: string[];
  setWatcherIds: (watchers: string[]) => void;
  users: ProcureUser[];
  onSave: () => void;
};
export function WatchersSelection(props: WatchersSelectionProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <Grid container sx={{ alignItems: 'center' }}>
      <Grid item>
        {props.watcherIds?.length > 0 ? (
          <UserAvatarGroup users={props.users.filter(user => props.watcherIds.includes(user.id))} />
        ) : (
          <Typography>Select watchers</Typography>
        )}
      </Grid>
      <Grid item>
        <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
          <KeyboardArrowDownRoundedIcon />
        </IconButton>
      </Grid>
      <DropdownWithCheckboxes
        entities={props.users}
        onClose={() => {
          setAnchorEl(null);
          props.onSave();
        }}
        onSave={() => props.onSave()}
        anchorEl={anchorEl}
        selectedIds={props.watcherIds}
        setSelectedIds={props.setWatcherIds}
        displayFieldKey={'fullName'}
      />
    </Grid>
  );
}
